"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MovingAverageImpression = void 0;
const investor_type_enum_1 = require("../../@types/incoming/enum/investor-type.enum");
const moving_average_indicator_enum_1 = require("../../@types/incoming/enum/moving-average-indicator.enum");
const specific_investor_mm_enum_1 = require("../../@types/outcoming/enum/specific-investor-mm.enum");
const moving_average_impressions_data_1 = require("./data/moving-average-impressions.data");
class MovingAverageImpression {
    constructor(investorType) {
        this.investorType = investorType;
    }
    getAll(movingAvgData) {
        const impressions = [];
        this.movingAvgData = movingAvgData;
        const specificIndication = this.getSpecificIndication();
        switch (specificIndication === null || specificIndication === void 0 ? void 0 : specificIndication.value) {
            case specific_investor_mm_enum_1.eSpecificInvestorMMInd.BUY:
                impressions.push(this.getImpression(0));
                break;
            case specific_investor_mm_enum_1.eSpecificInvestorMMInd.SELL:
                impressions.push(this.getImpression(1));
                break;
        }
        return impressions;
    }
    getSpecificIndication() {
        if (!this.movingAvgData) {
            return;
        }
        const data = this.movingAvgData;
        const investorType = this.investorType;
        const shortsPeriods = [
            data.MA5_EXP,
            data.MA5_SIM,
            data.MA10_EXP,
            data.MA10_SIM,
        ];
        const midPeriods = [
            data.MA20_EXP,
            data.MA20_SIM,
            data.MA50_EXP,
            data.MA50_SIM,
        ];
        const longPeriods = [
            data.MA100_EXP,
            data.MA100_SIM,
            data.MA200_EXP,
            data.MA200_SIM,
        ];
        switch (investorType) {
            case investor_type_enum_1.eInvestorType.DAY_TRADER:
                return {
                    name: 'Médias Móveis - Day Trader.',
                    value: this.determinePeriodSummary(shortsPeriods),
                    periods: [
                        {
                            name: 'MA 5 Périodos',
                            value: data.MA5_SIM,
                        },
                        {
                            name: 'EMA 5 Périodos',
                            value: data.MA5_EXP,
                        },
                        {
                            name: 'MA 10 Périodos',
                            value: data.MA10_SIM,
                        },
                        {
                            name: 'EMA 10 Périodos',
                            value: data.MA10_EXP,
                        },
                    ],
                };
            case investor_type_enum_1.eInvestorType.SWING_TRADER:
                return {
                    name: 'Médias Móveis - Swing Trader',
                    value: this.determinePeriodSummary(midPeriods),
                    periods: [
                        {
                            name: 'MA 20 Périodos',
                            value: data.MA20_SIM,
                        },
                        {
                            name: 'EMA 20 Périodos',
                            value: data.MA20_EXP,
                        },
                        {
                            name: 'MA 50 Périodos',
                            value: data.MA50_SIM,
                        },
                        {
                            name: 'EMA 50 Périodos',
                            value: data.MA50_EXP,
                        },
                    ],
                };
            case investor_type_enum_1.eInvestorType.BUY_AND_HOLDER:
                return {
                    name: 'Médias Móveis - Conservative Trader',
                    value: this.determinePeriodSummary(longPeriods),
                    periods: [
                        {
                            name: 'MA 100 Périodos',
                            value: data.MA100_SIM,
                        },
                        {
                            name: 'EMA 100 Périodos',
                            value: data.MA100_EXP,
                        },
                        {
                            name: 'MA 200 Périodos',
                            value: data.MA200_SIM,
                        },
                        {
                            name: 'EMA 200 Périodos',
                            value: data.MA200_EXP,
                        },
                    ],
                };
        }
    }
    determinePeriodSummary(indications) {
        let qntBuy = 0;
        let qntSell = 0;
        let qntNeutral = 0;
        indications.forEach((indication) => {
            switch (indication) {
                case moving_average_indicator_enum_1.eMovingAverageIndicator.NEUTRAL:
                    return qntNeutral++;
                case moving_average_indicator_enum_1.eMovingAverageIndicator.BUY:
                    return qntBuy++;
                case moving_average_indicator_enum_1.eMovingAverageIndicator.SELL:
                    return qntSell++;
            }
        });
        if (qntBuy > qntSell && qntBuy > qntNeutral) {
            return specific_investor_mm_enum_1.eSpecificInvestorMMInd.BUY;
        }
        else if (qntSell > qntBuy && qntSell > qntNeutral) {
            return specific_investor_mm_enum_1.eSpecificInvestorMMInd.SELL;
        }
        else {
            return specific_investor_mm_enum_1.eSpecificInvestorMMInd.NEUTRAL;
        }
    }
    getImpression(id) {
        return moving_average_impressions_data_1.movingAverageImpressionList.find((item) => item.id === id);
    }
}
exports.MovingAverageImpression = MovingAverageImpression;
//# sourceMappingURL=moving-average.impression.js.map